import teamProfileReducer from './reducers';

export { default as teamProfileOperations } from './operations';
export { default as teamProfileActions } from './actions';
export { default as teamProfileSelectors } from './selectors';

export default teamProfileReducer;
